import { Suspense, lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import BootSplash from '@/shared/components/BootSplash';
import ROUTES from '@/shared/constants/routes';

const SatIdRoute = lazy(() => import('../views/SatIdRoute'));

export const satIdRoutes: RouteObject = {
	id: 'sat-id',
	path: `${ROUTES.SAT_ID}/:tramite`,
	element: (
		<Suspense fallback={<BootSplash />}>
			<SatIdRoute />
		</Suspense>
	),
};
